import { NgClass } from '@angular/common'
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink, UrlTree } from '@angular/router'
import { HtmlAttributesDirective } from '../../../directives/html-attributes.directive'

@Component({
    selector: 'sq-sidebar-brand',
    imports: [RouterLink, HtmlAttributesDirective, NgClass],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './sidebar-brand.component.html',
})
export class SidebarBrandComponent {
    readonly brandFull = input<any>()
    readonly brandNarrow = input<any>()

    readonly routerLink = input<string | any[] | UrlTree | null | undefined>()

    readonly brandImg = computed(() => Boolean(this.brandFull() || this.brandNarrow()))
}
